import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Card from './card';
import { WbEventHandlerMixins, sanitize } from '../../../utils/common';
import * as CardAction from './../../actions/card.actions';
import ImgIconComp from '../../../components/imgcomp';
import { Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from 'uuid';
import DeleteCommonModal from "../../../components/deleteCommonModal.component";
import { generateSASAnduploadToTempLocation, WoboFileUploadService } from '../../../services/fileupload.service';
import GoalServices from '../../../services/goal.services'

const services = new GoalServices()

const FreeTextCard = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { columnId, id, fusDetail } = props;
  const { userPermission } = props.boardDetails;
  const sortableClass = "boardtray-sortable-item";
  const aiTileHighlight = "";
  const editPermission = userPermission.editBoard == "1";
  const isEditable = editPermission ? " isEditable " : "";
  const key = `${columnId}_${id}`;
  const divWrapClass = `boardFreeTextDiv_${id}`;
  const [editFreetext, seteditFreetext] = React.useState(false);
  const [showDeleteImg, setshowDeleteImg] = React.useState(false);
  const [freeTextDesc, setfreeTextDesc] = React.useState(props.description ? props.description : '');
  const [confirmPopup, setConfirmPopup] = React.useState(false);
  let myDropzone: any;
  const freetextValue = React.createRef<HTMLDivElement>();
  const scanningGif = `${wbConfig.baseCdnUrl}/images/loadimages/image_scan_2.gif`;
  React.useEffect(() => {
    window.addEventListener("click", saveFreeTextEdit, true);
    return () => {
      window.removeEventListener("click", saveFreeTextEdit, true);
    }
  }, []);

  const tempImgLocation = (id) => {
    let temImgLocation = wbConfig.baseUrl + '/images/loading.gif';
    const imgTagVal = `<img id="scan_${id}" class="imgViewerCtrl" src="${temImgLocation}" />`;
    return `<div class="ftImageDiv">${imgTagVal}</div>`;
  }

  React.useEffect(() => {
    if (props.fus_type == 1) {
      let loadImg = tempImgLocation(props.id)
      setfreeTextDesc(loadImg); //TODO: add loading icon to top of desc so other text will not be replaced
      let url = `${wbConfig.baseDomainUrl}` + '/vnext/fus/api/v1/download/' + props.file_signature;
      let description = props.description;
      if (props.fus_status == 1) {
        WoboFileUploadService.download(url).then(async (res) => {
          let blob = await res.blob();
          let blobUrl = URL.createObjectURL(new Blob([blob]));
          let desc = description.replace(`src="${url}"`, `src="${blobUrl}"`);
          setfreeTextDesc(desc);
        });
      } else {
        let desc = description.replace(`src="${url}"`, `src="${scanningGif}"`);
        setfreeTextDesc(desc);
      }
    } else {
      setfreeTextDesc(props.description || '');
    }
  }, [props.description])

  const saveFreeTextEdit = (e: any) => {
    const description = $.trim($(`#freetextValue_${props.id}`).html());
    const freeTxtContainer = $(`.boardFreeTextDiv_${id}`);
    if (
      description.length > 0 &&
      (!$(freeTxtContainer).is(e.target) &&
        $(freeTxtContainer).has(e.target).length === 0)
    ) {
      updateFreeText(description, null, null, null);
    }
  }

  const isDraggableDisabled = (id: string) => {
    if (id && id.includes("newFt_")) {
      return true;
    }
    return false;
  }

  const updateFreeText = (description: any, myObjectS3Data: any, file: any, fileSignature: string) => {
    const { columnId, id, actions, fus_type, fus_status, fileName, prefix, fileSize, s3DirectUpload, file_signature } = props;
    if (myObjectS3Data) {
      dispatch(CardAction.BoardUpdateS3Data(myObjectS3Data));
    }
    if (description != null && description.length > 0) {
      description = description.trim();
      const empDesc = description.replace("<br>", "").trim();
      if (empDesc.length > 0) {
        // Check if content changed before sanitizing
        if (description != props.description) {
          // Sanitize the description before saving to prevent stored XSS
          const sanitizedDescription = sanitize(description);
          seteditFreetext(false);
          setfreeTextDesc(sanitizedDescription);
          if (id && description && columnId) {
            const url = `${wbConfig.baseUrl}/board/savefreeText`;
            const params = { id, description: sanitizedDescription, columnId, fus_type, fus_status, fileName, prefix, fileSize, s3DirectUpload, file_signature };
            if (fusDetail.isFUSEnabled && file) {
              params.fus_type = 1;
              params.fus_status = 2;
              params.prefix = `FUS_${file.requestId}`;
              params.fileName = file.name;
              params.fileSize = file.size;
              params.s3DirectUpload = 2;
              params.file_signature = `FUS_${file.requestId}`;
            }
            $.post(url, params, resp => {
              if (fusDetail.isFUSEnabled && file) {
                let imgLocation =
                  `${wbConfig.baseDomainUrl}` +
                  '/vnext/fus/api/v1/download/' +
                  fileSignature;
                const imgLoad = tempImg();
                let description = resp.data.description;
                let desc = description.replace(`src="${imgLocation}"`, `src="${imgLoad}"`);
                dispatch(CardAction.BoardUpdateItemInColumn({ id, desc }));
                callProcessFileWithFus(file, resp.data.id)
              } else {
                dispatch(CardAction.BoardUpdateItemInColumn({ id, description: sanitizedDescription }));
              }
              removeLoaderWidget();
            });
          }
        } else {
          seteditFreetext(false);
        }
      }
    }
    try {
      removeLoaderWidget();
      myDropzone.destroy();
    } catch (err) {
      console.log(err);
    }
  }

  const tempImg = () => {
    return `${wbConfig.baseDomainUrl}` + '/images/loadimages/image_scan_2.gif';
  }

  const callProcessFileWithFus = (file, id) => {
    var userId = fusDetail.userId;
    var orgId = fusDetail.orgId;
    var fileDetails = {
      source_fileName: file.source_fileName,
      file_mimetype: file.type || 'image/jpeg',
      file_size: file.size,
      request_id: file.requestId,
      signature: `FUS_${file.requestId}`,
      isCropped: false,
      isPublic: false,
      appInID: fusDetail.appinID,
      byok_tenant_id: '',
      file_originalname: file.name,
      webhook_details: {
        host: `${wbConfig.baseDomainUrl}/fus/fusCallback?type=4&fid=${id}&cId=${columnId}}`,
        path: '',
      },
      orgId: orgId,
      userId: userId,
      target_folder: uuidv4(),
      freeTextId: id,
    }
    WoboFileUploadService.processFile(fileDetails).then(() => {
      updateFile(fileDetails.signature, 2000, fileDetails.freeTextId)
    })
    .catch((err) => {
      dispatch(
        CardAction.BoardDelteItemInColumn({
          id: id,
          colId: columnId,
        })
      )
      const url = `${wbConfig.baseUrl}/board/deleteFreeText`
      const params = { id: id }
      $.post(url, params)
      console.log(err)
    })
  }

  const updateFile = (signature, delayMs, freeTextId) => {
    const clearTimer = setInterval(async () => {
      services
        .getFileStatus({ signature, freeTextId })
        .then((response) => {
          const jsonData = response?.data
          if (jsonData) {
            if (
              jsonData?.resp?.fus_type == 1 &&
              jsonData?.resp?.fus_status == 1
            ) {
              clearInterval(clearTimer)
              const url = `${wbConfig.baseDomainUrl}` + '/vnext/fus/api/v1/download/' + signature;
              WoboFileUploadService.download(url).then(async (res) => {
                const blob = await res.blob();
                const blobUrl = URL.createObjectURL(new Blob([blob]));
                let id = jsonData?.resp?.id;
                const imgLoad = tempImg();
                let description = jsonData?.resp?.description
                let desc = description.replace(`src="${imgLoad}"`, `src="${blobUrl}"`);
                dispatch(CardAction.BoardUpdateItemInColumn({ id, desc }));
              })
            }
          }
        })
        .catch((err) => { })
    }, delayMs)
  }

  const editFreeTextVal = (e: any, editPermission: any) => {
    if (
      editPermission &&
      !$(".freeTextTileDelete").is(e.target) &&
      !$(".imgViewerCtrl").is(e.target)
    ) {
      $(".freeTextTileDelete").hide();
      seteditFreetext(true);
      setshowDeleteImg(false);
      const elementId = `freetextValue_${props.id}`;
      setTimeout(() => {
        if (elementId.length > 0 && $(`#${elementId}`).length) {
          WbEventHandlerMixins.placeCaretAtEnd($(`#${elementId}`).get(0));
        }
        initializeDropzone({
          s3Data: props.boardDetails.s3Data,
          updateFreeText: updateFreeText,
          elementId,
          upload_max_size: props.boardDetails.upload_max_size,
          upload_max_size_configured:
            props.boardDetails.upload_max_size_configured
        });
      }, 500);
    }
  }

  const showTrashCan = (editPermission: any) => {
    if (editPermission) {
      setshowDeleteImg(!editFreetext);
    }
  }

  const hideTrashCan = () => {
    setshowDeleteImg(false);
  }

  const deleteSingleTile = () => {
    setConfirmPopup(true);
  }

  const cancelAlertBox = () => {
    setConfirmPopup(false);
  }

  const deleteSinglefreeText = () => {
    setConfirmPopup(false);
    const { userPermission } = props.boardDetails;
    const editPermission = userPermission.editBoard == "1";
    if (editPermission) {
      dispatch(CardAction.BoardDelteItemInColumn({ id: props.id, colId: props.columnId }));
      const url = `${wbConfig.baseUrl}/board/deleteFreeText`;
      const params = { id };
      $.post(url, params);
      if (props.fus_type == 1) {
        WoboFileUploadService.delete(props.file_signature);
      }
    }
  }

  const initializeDropzone = (props: any) => {
    const ftS3Data = props.s3Data;
    const _this = this;
    let urlVal = `https://${ftS3Data.file_bucket}.s3.amazonaws.com/`;
    const getS3Url = `${wbConfig.baseUrl}/workboard/getS3Data`;
    const eleId = `#${props.elementId}`;
    const { upload_max_size } = props;
    const { upload_max_size_configured } = props;
    if (fusDetail.isFUSEnabled) {
      urlVal = `${wbConfig.baseDomainUrl}/vnext/fus/api/v1/sastoken`;
    }
    myDropzone = new Dropzone(eleId, {
      url: urlVal,
      autoProcessQueue: false,
      autoDiscover: false,
      uploadMultiple: false,
      acceptedFiles:
        "image/jpeg, image/png, image/gif, image/jpg, image/bmp, image/tiff",
      thumbnailMethod: "crop",
      parallelUploads: 100,
      clickable: false,
      maxFilesize: upload_max_size_configured,
      init() {
        const myDropzone = this;
        myDropzone.on("addedfile", function (file: any) {
          try {
            setTimeout(() => {
              // showLoaderWidget($("#content"));
              myDropzone.processQueue();
            }, 500);
          } catch (err) {
            console.log("Unable to upload file");
          }
        });
        myDropzone.on("sending", (file: any, xhr: any, formData: any) => {
          showLoaderWidget($("#content"));
          if (!fusDetail.isFUSEnabled) {
            const fileName = file.name;
            const fileType = file.type;
            const key = replaceS3Key(ftS3Data.key, fileName);
            formData.append("key", key);
            // check the acl in the data
            if (ftS3Data.acl == "public-read") {
              formData.append("acl", "public-read");
              formData.append("AWSAccessKeyId", ftS3Data.keyId);
              formData.append("policy", ftS3Data.policy);
              formData.append("signature", ftS3Data.signature);
              formData.append("success_action_status", 201);
              formData.append("Filename", replaceSpcicalCharacter(fileName));
              formData.append("Content-type", fileType);
            } else {
              formData.append("policy", ftS3Data.policy);
              formData.append("success_action_status", 201);
              formData.append("Filename", replaceSpcicalCharacter(file.name));
              formData.append("acl", "authenticated-read");
              if (
                typeof ftS3Data.encrypt_type !== "undefined" &&
                ftS3Data.encrypt_type == "aws:kms"
              ) {
                formData.append("x-amz-algorithm", ftS3Data.algo);
                formData.append("x-amz-credential", ftS3Data.credential);
                formData.append("x-amz-date", ftS3Data.short_date);
                formData.append("x-amz-signature", ftS3Data.signature);
              } else if (
                typeof ftS3Data.encrypt_type !== "undefined" &&
                ftS3Data.encrypt_type == "aws:ssc"
              ) {
                const enKeys = JSON.parse(ftS3Data.encrypt_keys);
                formData.append("AWSAccessKeyId", ftS3Data.keyId);
                formData.append("signature", ftS3Data.signature);
                formData.append(
                  "x-amz-server-side-encryption-customer-algorithm",
                  "AES256"
                );
                formData.append(
                  "x-amz-server-side-encryption-customer-key",
                  enKeys.base64
                );
                formData.append(
                  "x-amz-server-side-encryption-customer-key-MD5",
                  enKeys.digest
                );
              } else {
                formData.append("AWSAccessKeyId", ftS3Data.keyId);
                formData.append("signature", ftS3Data.signature);
                formData.append("x-amz-server-side-encryption", "AES256");
              }
              formData.append("Content-type", file.type);
              // formData.append("file", file);
            }
            file.prefix = ftS3Data.prefix;
          } else {
            var requestId = uuidv4()
            generateSASAnduploadToTempLocation(file, {
              appinID: fusDetail.appinID,
              request_id: requestId,
              accessToken: fusDetail.accessToken,
              userId: fusDetail.userId,
              orgId: fusDetail.orgId,
            }).then((fname) => {
              var paramsData = {
                s3DirectUpload: file.s3DirectUpload,
                s3key: '',
                prefix: '',
                fileName: replaceSpcicalCharacter(file.name),
                fileSize: file.size
              };
              paramsData['fus_type'] = 1;
              paramsData['fus_status'] = 2;
              paramsData['s3DirectUpload'] = 2;
              paramsData['prefix'] = "FUS_" + requestId;

              file.source_fileName = fname
              file.requestId = requestId
              let fileSignature = `FUS_${requestId}`
              let imgLocation =
                `${wbConfig.baseDomainUrl}` +
                '/vnext/fus/api/v1/download/' +
                `${fileSignature}`;

              let exisDesc = $(eleId).html();
              if (exisDesc == undefined) {
                exisDesc = '';
              }
              let imgTagVal = `<img class="imgViewerCtrl ftImage" src="${imgLocation}"  />`;
              if ($(exisDesc).hasClass("ftImageDiv")) {
                $(eleId)
                  .find(".ftImageDiv")
                  .append(imgTagVal);
                exisDesc = $(eleId).html();
              } else {
                exisDesc = `<div class="ftImageDiv">${exisDesc}${imgTagVal}</div>`;
              }
              updateFreeText(exisDesc, null, file, fileSignature)
            })
          }
        });
        myDropzone.on("success", (file: any, response: any) => {
          if (!fusDetail.isFUSEnabled) {
            let imgLocation = $("Location", response).text();
            const imgKey = $("Key", response).text();
            const bucket = $("Bucket", response).text();
            let acl = "public-read";
            const s3FormData: any = {};
            if (bucket.toLowerCase().indexOf("workboard") == -1) {
              acl = "authenticated-read";
              s3FormData.imgUrl = imgLocation;
              s3FormData.imgKey = imgKey;
            }
            s3FormData.authVal = acl;
            $.ajax({
              url: getS3Url,
              type: "POST",
              dataType: "json",
              data: s3FormData
            }).done(data => {
              const myObjectS3Data = data;
              let exisDesc = $(eleId).html();
              if (exisDesc == undefined) {
                exisDesc = '';
              }
              if (typeof myObjectS3Data.imgUrl !== "undefined") {
                imgLocation = myObjectS3Data.imgUrl;
              }
              const imgTagVal = `<img class="imgViewerCtrl ftImage" src="${imgLocation}"  />`;
              if ($(exisDesc).hasClass("ftImageDiv")) {
                $(eleId)
                  .find(".ftImageDiv")
                  .append(imgTagVal);
                exisDesc = $(eleId).html();
              } else {
                exisDesc = `<div class="ftImageDiv">${exisDesc}${imgTagVal}</div>`;
              }
              props.updateFreeText(exisDesc, myObjectS3Data);
            });
          }
          myDropzone.destroy();
        });
        myDropzone.on("error", (files: any, response: any, xhr: any) => {
          try {
            alert(t("Unable to upload file. Please try again later."));
            $.ajax({
              url: getS3Url,
              type: "POST",
              dataType: "json",
              data: { authVal: "public-read" }
            }).done(data => {
              const myObjectS3Data = data;
              props.updateFreeText(null, myObjectS3Data);
              removeLoaderWidget();
            });
            removeLoaderWidget();
            myDropzone.destroy();
          } catch (err) { }
        });
      }
    });
  };

  const getItemStyle = (isDragging: boolean, draggableStyle: any) => {
    const { transform, ...rest } = draggableStyle;
    let style = {
      // some basic styles to make the items look a bit nicer
      userSelect: "none",
      // styles we need to apply on draggables
      ...draggableStyle,
    }
    if (isDragging && transform) {
      let containerCoordinates = document.querySelector(".mainBoardWrapper").getBoundingClientRect();

      let trArray = transform.substring(10, transform.length - 1).split(",");
      let transX = draggableStyle.left + parseInt(trArray[0].trim().substring(0, trArray[0].length - 2));
      let transY = draggableStyle.top + parseInt(trArray[1].trim().substring(0, trArray[1].length - 2));

      if (transY < containerCoordinates.top - 10) {
        if (transX > containerCoordinates.left) {
          style.transform = `translate(${transX - draggableStyle.left}px, -${draggableStyle.top - (containerCoordinates.top - 10)}px)`;
        } else {
          style.transform = `translate(-${draggableStyle.left - containerCoordinates.left}px, -${draggableStyle.top - (containerCoordinates.top - 10)}px)`;
        }

      } else if (transX < containerCoordinates.left) {
        style.transform = `translate(-${draggableStyle.left - containerCoordinates.left}px, ${transY - draggableStyle.top}px)`;
      } else {
        style.transform = transform;
      }
    }
    return style;
  };

  return (
    <Draggable draggableId={`drag-item-${id}`} index={props.index} isDragDisabled={isDraggableDisabled(id)} >
      {
        (provided: any, snapshot: any) => (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <Card>
              <Card.Body>
                <div
                  key={props.index}
                  className={` shardWsBoard ${sortableClass} ${aiTileHighlight} ${isEditable}`}
                  data-value={props.id}
                  onMouseEnter={() => showTrashCan(editPermission)}
                  onMouseLeave={hideTrashCan}
                >
                  <div className={`boardFreeTextWrap ${divWrapClass}`}>
                    {showDeleteImg && (
                      <div
                        className="freeTextTileDelete"
                        onClick={() => deleteSingleTile()}
                      >
                        <ImgIconComp id="delete_image" width="12" height="12" />
                      </div>
                    )}
                    {!editFreetext && (
                      <div
                        className="freeTextData"
                        onClick={e => editFreeTextVal(e, editPermission)}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: sanitize(freeTextDesc || '') }}
                        />
                      </div>
                    )}
                    {editFreetext && (
                      <div
                        className="freetextValue"
                        ref={freetextValue}
                        id={`freetextValue_${props.id}`}
                        contentEditable="true"
                        dangerouslySetInnerHTML={{ __html: sanitize(freeTextDesc || '') }}
                      />
                    )}
                  </div>
                </div>
                {confirmPopup && (
                  <DeleteCommonModal
                    exitDeleteModal={cancelAlertBox}
                    deleteItems={deleteSinglefreeText}
                    id=""
                    title={t("Confirm Deletion")}
                    deleteContentSecond={t("Are you sure you want to delete the free text ?")}
                    deleteContentOne=""
                    deleteContentSecondParam=""
                    deletefirstTitle=""
                    buttonText={t("Yes")}
                  />
                )}
              </Card.Body>
            </Card>
          </div>
        )
      }
    </Draggable>
  )
}

export default memo(FreeTextCard);

